import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getBrand,
  getDateRange,
  getLocation,
  getSubCategory,
} from "./constant.thunk";
import { getSource } from "../../../utils/helpers";

const init_state = {
  brand: [],
  allLocation: [
    // New Zealand domestic locations
    "sephora",
    "beauty_bliss",
    "farmers",
    "nz_liquor",
    "big_barrel",
    "chemist_warehouse",
    "whisky_and_more",
    "mecca",
    // Australian domestic locations
    "au_chemist_warehouse",
    "au_mecca",
    "au_sephora",
    "the_iconic",
    "danmurphy",
  ],
  location: [
    // New Zealand domestic locations
    "sephora",
    "beauty_bliss",
    "farmers",
    "nz_liquor",
    "big_barrel",
    "chemist_warehouse",
    "whisky_and_more",
    "mecca",
    // Australian domestic locations
    "au_chemist_warehouse",
    "au_mecca",
    "au_sephora",
    "the_iconic",
    "danmurphy",
  ],
  loadingLocation: true,
  date_range: {},
  sub_category: [],
  loadingSubCategory: true,
  source: "aelia_auckland",
  currency: "NZD",
};

// Locations that must be hidden from all frontend filters
const excludedLocations = ["nz_themall"];

export const fetchAllBrandAsyncThunk = createAsyncThunk(
  "fetchAllBrand",
  getBrand
);
export const fetchAllSubCategoryAsyncThunk = createAsyncThunk(
  "fetchAllSubCategory",
  getSubCategory
);
export const fetchAllLocationAsyncThunk = createAsyncThunk(
  "fetchAllLocation",
  getLocation
);
export const fetchDateRangeAsyncThunk = createAsyncThunk(
  "fetchDateRange",
  getDateRange
);

const constantSlice = createSlice({
  name: "Constant slice",
  initialState: init_state,
  reducers: {
    setBrandData: (state, action) => {
      const temp = action.payload;
      const data = [];
      temp.forEach((item) => {
        data.push(item.brand);
      });

      state.brand = data;
    },
    setSubCategoryData: (state, action) => {
      const temp = action.payload;
      const data = [];
      temp.forEach((item) => {
        data.push(item.sub_category);
      });

      state.sub_category = data;
    },
    setLocationData: (state, action) => {
      const temp = action.payload;
      const data = [];
      temp.forEach((item) => {
        if (!excludedLocations.includes(item.website)) {
          data.push(item.website);
        }
      });

      state.location = [...init_state.location, ...data].filter(
        (w) => !excludedLocations.includes(w)
      );
    },
    setDataRange: (state, action) => {
      state.date_range = action.payload;
    },
    setSource: (state, action) => {
      state.source = action.payload;
      
      // Define source-specific location filtering
      const nzSources = ['aelia_auckland', 'aelia_queenstown', 'aelia_christchurch'];
      const auSources = ['heinemann_sydney', 'heinemann_goldcoast', 'lotte_melbourne', 'lotte_brisbane', 'aelia_cairns', 'aelia_adelaide'];
      
      // Set currency based on user source
      if (nzSources.includes(action.payload)) {
        // New Zealand based sources - set currency to NZD
        state.currency = "NZD";
      } else if (auSources.includes(action.payload)) {
        // Australia based sources - set currency to AUD
        state.currency = "AUD";
      } else if (action.payload === 'ishopchangi') {
        state.currency = "SGD";
      }
      
      state.location = state.location
        .filter((i) => i !== action.payload)
        .filter((w) => !excludedLocations.includes(w));
    },
    setCurrency: (state, action) => {
      state.currency = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBrandAsyncThunk.pending, (state) => {
        return state;
      })
      .addCase(fetchAllBrandAsyncThunk.fulfilled, (state) => {
        return state;
      })
      .addCase(fetchAllBrandAsyncThunk.rejected, (state) => {
        return state;
      })
      .addCase(fetchAllSubCategoryAsyncThunk.pending, (state) => {
        state.loadingSubCategory = true;
        return state;
      })
      .addCase(fetchAllSubCategoryAsyncThunk.fulfilled, (state) => {
        state.loadingSubCategory = false;
        return state;
      })
      .addCase(fetchAllSubCategoryAsyncThunk.rejected, (state) => {
        state.loadingSubCategory = false;
        return state;
      })
      .addCase(fetchAllLocationAsyncThunk.pending, (state) => {
        state.loadingLocation = true;
      })
      .addCase(fetchAllLocationAsyncThunk.fulfilled, (state, action) => {
        state.loadingLocation = false;
        const temp = action.payload.data;
        const data = [];
        temp.forEach((item) => {
          if (!excludedLocations.includes(item.website)) {
            data.push(item.website);
          }
        });
        state.allLocation = [...init_state.allLocation, ...data].filter(
          (w) => !excludedLocations.includes(w)
        );
        
        // Use the locations returned from backend directly (backend already filters correctly)
        // Just remove the current source from the list
        state.location = data
          .filter((w) => w !== state.source)
          .filter((w) => !excludedLocations.includes(w));
      })
      .addCase(fetchAllLocationAsyncThunk.rejected, (state) => {
        state.loadingLocation = false;
      })
      .addCase(fetchDateRangeAsyncThunk.pending, (state) => {
        return state;
      })
      .addCase(fetchDateRangeAsyncThunk.fulfilled, (state, action) => {
        state.date_range = action.payload.data[0];
        return state;
      })
      .addCase(fetchDateRangeAsyncThunk.rejected, (state) => {
        return state;
      });
  },
});

export const {
  setBrandData,
  setLocationData,
  setDataRange,
  setSource,
  setSubCategoryData,
  setCurrency,
} = constantSlice.actions;
export default constantSlice.reducer;
